import { Pagination } from 'antd';

export type TableSearchProps = {
  readonly limit: number;
  readonly offset: number;
};

type TablePaginationProps = {
  readonly currentPage: number;
  readonly itemsPerPage: number;
  readonly total: number;
} & TablePaginationFunctionProps;

type TablePaginationFunctionProps = {
  readonly onPageChange: (pageNumber: number) => void;
};

export const getTableSearchProps = (
  itemsPerPage: number,
  pageNumber: number
) => ({
  limit: itemsPerPage,
  offset: (pageNumber - 1) * itemsPerPage,
});

/**
 * Provides a generic pagination section for table data.
 */
const TablePagination = ({
  currentPage,
  itemsPerPage,
  total,
  onPageChange,
}: TablePaginationProps) => {
  return (
    <Pagination
      current={currentPage}
      defaultPageSize={itemsPerPage}
      showSizeChanger={false}
      onChange={onPageChange}
      style={{ alignSelf: 'end' }}
      total={total}
    />
  );
};

export default TablePagination;
